import Vue from "vue";
import VueCompositionAPI from '@vue/composition-api'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "normalize.css";
import VueLazyload from 'vue-lazyload'
// import * as Sentry from "@sentry/vue";
// import packageJson from '../package.json';
import config from './utils/config'
// import './assets/style/color-tc.scss';

import {
  Swipe,
  SwipeItem,
  Form,
  Field,
  Popup,
  Toast,
  Picker,
  Overlay,
  Loading,
  Icon,
  Popover,
  Dialog,
  Button,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  ActionSheet,
  Tag,
  List,
  PullRefresh,
  Image as VanImage,
  Uploader
} from "vant";
import Modal from "./components/modal/index";
import api from "./api/index"

Vue.config.productionTip = false;
Vue.config.ignoredElements = ["wx-open-launch-app","wx-open-launch-weapp"];

// if (packageJson && packageJson.isBuild) {
//   Sentry.init({
//     Vue,
//     dsn: "https://4eeb42ad38dd472581c0b9329d8f8fab@sentryprod.cotticoffee.com/15",
//     integrations: [
//       // new Sentry.BrowserTracing({
//       //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       //   tracingOrigins: ["localhost", "my-site-url.com", /^/],
//       // }),
//     ],
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 0.1,
//     environment: process.env.VUE_APP_ENV || 'prod',
//     release: packageJson?.name + '@' + packageJson?.branch

//   });
// }


function queryURLParams(URL) { // 取url参数
  if (URL.indexOf("?") !== -1) {
    let url = URL.split("?")[1];
    let obj = {}; // 声明参数对象
    let arr = url.split("&"); // 以&符号分割为数组
    for (let i = 0; i < arr.length; i++) {
      let arrNew = arr[i].split("="); // 以"="分割为数组
      obj[arrNew[0]] = arrNew[1];
    }
    return obj;
  }
}
const distinct_id = queryURLParams(location.href)?.contact_id;


try {
  const token = queryURLParams(location.href)?.u_t;
  token && sessionStorage.setItem('COTTI_USER_TOKEN', token)
} catch (e) {
  console.warn('queryURLParams(location.href)?.u_t;', e, location.href)
}

function sensorsToOnLine () { // 埋点向电商发送数据，目前有通用领券页、社群福利页
  if (location.href.indexOf('onlineqrcode') !== -1 || location.href.indexOf('ticket') !== -1) {
    return true;
  }
  return false;
}
import sensors from "sa-sdk-javascript";

if (sensorsToOnLine()) { // 此判断埋点地址发送到电商小程序的数据接收地址
  sensors.init({
    server_url: process.env.VUE_APP_SERVER_URL_ONLINE,
    is_track_single_page: true,
    app_js_bridge: true,
    use_client_time: true,
    send_type: "beacon",
    heatmap: {
      clickmap: "not_collect",
      scroll_notice_map: "not_collect",
    },
    // 是否允许控制台打印查看埋点数据(建议开启查看)
    show_log: false
  });
  sensors.identify(distinct_id, true)
} else { // 此判断埋点地址发送到舌尖英雄小程序的数据接收地址
  sensors.init({
    server_url: process.env.VUE_APP_SERVER_URL,
    is_track_single_page: true,
    app_js_bridge: true,
    use_client_time: true,
    send_type: "beacon",
    heatmap: {
      clickmap: "not_collect",
      scroll_notice_map: "not_collect",
    },
    // 是否允许控制台打印查看埋点数据(建议开启查看)
    show_log: false
  });
}
// sensors.quick("autoTrack"); //访问浏览量过大，导致页面加载不出来
Vue.prototype.$sensors = sensors;
Vue.prototype.$config = config;

Vue.prototype.$api = api
// if (process.env.VUE_APP_BRAND == "TeaCat") {
//   Vue.prototype.$color = colorTC
// } else {
//   Vue.prototype.$color = color
// }

Vue.prototype.stopScroll = function () {
  var mo = function (e) { e.preventDefault() }
  document.body.style.overflow = 'hidden'
  document.addEventListener('touchmove', mo, false)// 禁止页面滑动
}

//弹出框可以滑动
Vue.prototype.canScroll = function () {
  var mo = function (e) {
    e.preventDefault()
  }
  document.body.style.overflow = ''// 出现滚动条
  document.removeEventListener('touchmove', mo, false)
}

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Form);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Modal);
Vue.use(Icon);
Vue.use(Popover);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(ActionSheet);
Vue.use(Tag);
Vue.use(VanImage);
Vue.use(VueLazyload);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Uploader);
Vue.use(VueCompositionAPI)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
